// extracted by mini-css-extract-plugin
module.exports = {"layout":"signup_up_layout-module__layout--e6n05"};